const config = {
  defaultPath: "/home",
  // baseUrl: 'https://timesheet-api.hopeagro.co.th/api/',
  baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  // baseUrl: "https://localhost:443/api/", // เปลี่ยนเป็น https://localhost:443
  // baseUrl: "http://68.183.187.13:8000/api/",
};

export default config;
